module.exports = __webpack_public_path__ + "img/pic_3.a9cff45f.jpg";